import { useState, useEffect, useRef, useCallback } from 'react'

export const useResendCountdown = (durationSeconds = 20) => {
  const [countdown, setCountdown] = useState(0)
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null)

  const startCountdown = useCallback(() => {
    setCountdown(durationSeconds)
  }, [durationSeconds])

  const clearTimer = useCallback(() => {
    if (intervalRef.current !== null) {
      clearInterval(intervalRef.current)
      intervalRef.current = null
    }
  }, [])

  const isCountingDown = countdown > 0

  useEffect(() => {
    if (!isCountingDown) {
      clearTimer()
      return
    }

    intervalRef.current = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearTimer()
          return 0
        }
        return prev - 1
      })
    }, 1000)

    return clearTimer
  }, [isCountingDown, clearTimer])

  return { countdown, startCountdown }
}
